import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentCompany } from '../../../features/company/companySlice';
import { useGetRegionsQuery } from '../../../features/regions/regionsApi';
import { useUserInfo } from '../../../features/user/userApi';
import { ContainerOutlined } from '@ant-design/icons';
import { ResponsiveButton } from '../../../features/responsive';

const HelpCenter = () =>{
	const { i18n, t } = useTranslation();
	const data = useUserInfo();
	const { data: regions } = useGetRegionsQuery(undefined, {skip:data.id === undefined});
	const company = useCurrentCompany();
	
	const feedbackUrl = useMemo(() => {
		let link;
	
		if (regions == null || company == null) {
		  return link;
		}
		const region = regions.find(r => r.code === company.country);

		if (region == null) {
		  return link;
		}
	
		try {
		  const configJson = JSON.parse(region.config);
		  if (configJson.vlt_feedback_url) {
			link = configJson.vlt_feedback_url;
		  }
		} 
		catch {
		  console.error('Region has no config or config json has format problem.');
		}
		return link;
	  }, [company, regions]);

	return (
		<ResponsiveButton
			type="link"
			size={"large"}
			onClick={() => {
				window.open(feedbackUrl, "_blank")
			}}
			title={t("VehicleModel.ReportIssue")} icon={<ContainerOutlined />}
			showSmallerText={true}
		/>
	);
}

export default HelpCenter;
